import { Constant } from '@configs/index';
import { InputDate } from '@molecules/Forms';
import { DashboardFormType } from '@organisms/GenesisEs/Forms/DashboardFormType';
import { Storage } from '@states/Storage';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';

type Props = {
    submitHandler: any;
};

const clearValues: DashboardFormType = Constant.SEARCH_FORM_DATA.DASHBOARD;

const DashboardForm = (props: Props) => {
    const defaultValues: DashboardFormType = Storage.get(Storage.keys.GENESISES_DASHBOARD);
    const { register, handleSubmit, setValue, getValues, clearErrors } = useForm<DashboardFormType>({ defaultValues });
    const onClear = () => {
        clearErrors();
        setValue('date', clearValues.date);
    }
    const onSubmit: SubmitHandler<DashboardFormType> = (data: DashboardFormType) => {
        data.timestamp = new Date().getTime();
        Storage.set(Storage.keys.GENESISES_DASHBOARD, data);
        props.submitHandler(data);
    }

    return (
        <FormWithStyled>
            <TableWithStyled className='searchTable'>
                <TBodyWithStyled>

                    <RowWithStyled>
                        <HeadWithStyled>
                            <Form.Label>
                                <LabelWithStyled>期間</LabelWithStyled>
                            </Form.Label>
                        </HeadWithStyled>
                        <BodyWithStyled>
                            <InputDate
                                register={register}
                                controlId='date'
                                setValue={setValue}
                                getValues={getValues}
                            />
                        </BodyWithStyled>
                    </RowWithStyled>

                </TBodyWithStyled>
            </TableWithStyled>

            <ButtonsWithStyled>
                <Button variant='secondary' size='sm' onClick={onClear}>　クリア　</Button>{' '}
                <Button variant='primary' size='sm' onClick={handleSubmit(onSubmit)}>　検　索　</Button>
            </ButtonsWithStyled>

        </FormWithStyled>
    )
};


const FormWithStyled = styled.form`
    margin: 5px 5px 10px;
`
const TableWithStyled = styled.table`
`
const TBodyWithStyled = styled.tbody`
`
const RowWithStyled = styled.tr`
`
const HeadWithStyled = styled.th`
`
const BodyWithStyled = styled.td`
`
const LabelWithStyled = styled.span`
`
const ButtonsWithStyled = styled.div`
    & button + button {
        margin-left:10px;
    }
`

export default DashboardForm;